<div class="sent-dialog">
  <h1 class="title">{{ 'NEW_CONTRACTS.PAPER_SIGNATURE' | i18nextEager }}</h1>
  <p class="text">{{ 'NEW_CONTRACTS.HAS_BEEN_SENT_PAPER' | i18nextEager }}</p>
  <img class="ok" src="/assets/icons/ok.svg" alt="{{ 'NEW_CONTRACTS.HAS_BEEN_SENT' | i18nextEager }}" />
  <div class="buttons">
    <button class="primary" (click)="send()">{{ 'COMMONS.OK' | i18nextEager }}</button>
  </div>
</div>
